import React, { useState } from 'react'
import { useAuth } from '../../../hooks/useAuth'
import OrganizationForm from './_components/OrganizationForm'
import loginImage from '../../../assets/images/ic_login_img.png'

export default function OrganizationCodePage(): React.JSX.Element {
  const [code, setCode] = useState('')
  const {
    isLoading,
    error,
    validateOrganizationCode,
    navigateToLogin,
    clearError
  } = useAuth()

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault()

    if (!code.trim()) {
      return
    }

    const isValid = await validateOrganizationCode(code.trim())
    if (isValid) {
      navigateToLogin(code.trim())
    }
  }

  const handleCodeChange = (newCode: string) => {
    setCode(newCode)
    // 清除之前的错误信息
    if (error) {
      clearError()
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* 左侧插图区域 */}
      <div className="hidden lg:flex lg:flex-1 lg:flex-col lg:justify-center lg:items-center lg:px-10 xl:px-10">
        <div className="max-w-lg w-full">
          <img
            src={loginImage}
            alt="Welcome Illustration"
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* 右侧表单区域 */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8 xl:px-12 bg-white lg:max-w-md xl:max-w-lg">
        <div className="mx-auto w-full max-w-sm">
          <OrganizationForm
            code={code}
            onCodeChange={handleCodeChange}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            error={error}
          />
        </div>

        {/* 底部语言选择 */}
        {/* <div className="absolute bottom-6 left-6">
          <button className="flex items-center text-sm text-gray-500 hover:text-gray-700">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            EN
            <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div> */}
      </div>
    </div>
  )
}
